import React from 'react'
import { Container, Box, Typography, Skeleton } from '@mui/material'

type AllBusinessStatsProps = {
  found?: number
  removed?: number
  optOutSubmitted?: number
  loading?: boolean
}

const AllBusinessStats: React.FC<AllBusinessStatsProps> = ({
  found,
  removed,
  optOutSubmitted,
  loading = false,
}) => {
  const renderStat = (
    label: string,
    value?: number,
    description?: string,
    background?: string
  ) => (
    <Box
      sx={{
        width: { xs: '100%', sm: '100%', md: '357px', lg: '342px' },
        minHeight: '178px',
        borderRadius: '6.84px',
        p: '28.33px 21.5px',
        display: 'flex',
        flexDirection: 'column',
        gap: '29.31px',
        background,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4.89px' }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '16px',
            textTransform: 'uppercase',
            color: '#fff',
          }}
        >
          {label}
        </Typography>

        {loading ? (
          <Skeleton
            variant="text"
            width={120}
            height={40}
            sx={{ bgcolor: 'rgba(255,255,255,0.3)', borderRadius: '4px' }}
          />
        ) : (
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: '32px',
              textTransform: 'uppercase',
              color: '#fff',
            }}
          >
            {value?.toLocaleString() ?? 0}
          </Typography>
        )}
      </Box>

      <Typography sx={{ fontSize: '14px', color: '#fff' }}>
        {description}
      </Typography>
    </Box>
  )

  return (
    <Container
      maxWidth={false}
      sx={{ maxWidth: '100%', mt: '20px', px: '0 !important' }}
    >
      <Typography variant="h6" fontWeight={600}>
        All Time Business Stats
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '20px', mt: '20px' }}>
        {renderStat(
          'Total Records Found',
          found,
          'Total records identified across all brokers.',
          'linear-gradient(105.13deg, #010039 0%, #331577 55.09%, #9635D4 100%)'
        )}
        {renderStat(
          'Total Records Removed',
          removed,
          'Successfully deleted from broker sites.',
          'linear-gradient(105.13deg, #010039 0%, #1A3493 53.02%, #4368F5 100%)'
        )}
        {renderStat(
          'Submitted Opt-Outs',
          optOutSubmitted,
          'Total requests submitted.',
          'linear-gradient(105.13deg, #010039 0%, #005176 55.09%, #019A95 100%)'
        )}
      </Box>
    </Container>
  )
}

export default AllBusinessStats
